function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.57142 17H1V1H14V5.57143V9.57142",
  stroke: "#4D88FF",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10 17V9",
  stroke: "#4D88FF",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M6 13H14",
  stroke: "#4D88FF",
  strokeWidth: 1.5,
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

const SvgNewAr = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgNewAr, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new_ar.c734d38a.svg";
export { ForwardRef as ReactComponent };